<div class="row welcome">
  <div class="col"></div>
  <div class="col-md-12 col-lg-10 col-xl-8 pt-5 pb-4 ">
    <div class="row">

        <div class="col-md-8" style="color:white; font-stretch: 100%; width:500px;">
            <div class="d-flex ">
              <div class="text-links"><a style="color:white" href="http://www.southeastwater.com.au/" title="Home"
                  role="link">Home</a></div>
              <div class="text-links"><a style="color:white"
                  href="assets/HydrotrakPortalTC.pdf" title="Terms of use" role="link">Terms
                  of use</a></div>
              <div class="text-links"><a style="color:white"
                  href="https://southeastwater.com.au/about-us/corporate-information/our-policies/privacy-charter/" title="Privacy policy"
                  role="link">Privacy charter</a></div>
              <!-- <div class="text-links"><a style="color:white"
                  href="http://www.southeastwater.com.au/Other/Pages/Feedback.aspx" title="Feedback"
                  role="link">Feedback</a></div>
              <div class="text-links"><a style="color:white"
                  href="http://www.southeastwater.com.au/Other/Pages/SiteMap.aspx" title="Sitemap" role="link">Site
                  map</a></div> -->
            </div>
            <div class="copyright ">&copy; 2019 South East Water Corporation&nbsp;&nbsp;&nbsp;ABN 89 066 902 547</div>
  
          </div>
  
          <div class="col-md-4 text-right">
            
              <a href="http://www.facebook.com/SEWmelbourne" title="Follow South East Water on Facebook" role="link"
                class="facebook" target="_blank">
                <img src="assets/img/icon-facebook.png" alt="Follow South East Water on Facebook" /></a>&nbsp;
              <a href="http://www.twitter.com/southeastwater" title="Follow South East Water on twitter" role="link"
                class="twitter" target="_blank">
                <img src="assets/img/icon-twitter.png" alt="Follow South East Water on twitter" /></a>&nbsp;
              <a href="http://www.youtube.com/southeastwater" title="Follow South East Water on You Tube" role="link"
                class="'youtube" target="_blank">
                <img src="assets/img/icon-youtube.png" alt="Follow South East Water on You Tube" /></a>&nbsp;
           
  
          </div>
    </div>
  </div>
  <div class="col"></div>
</div>


